import { apiSlice } from "../../../api/ApiService";

const postPatientStatusTransitionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postPatientStatusTransitions: builder.mutation({
      query: ({ body, accessToken }) => ({
        url: `/api/v1/Administration/patient-status-transitions`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        data:body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { usePostPatientStatusTransitionsMutation } = postPatientStatusTransitionApi;
export default postPatientStatusTransitionApi;
